import { AddressValidationStatus, Countries } from "@utils/enums";

import { CreateAddress } from "@redux/modules/api/data/address/address.types";
import { Address } from "@redux/modules/api/data/addressbook/addressbook.types";
import { CartModel } from "@redux/modules/api/data/cart/@types/cart.model";

export function formatAddressStreetLine(
    street: string,
    number: string,
    box?: string | null,
): string {
    return `${street} ${number}${(box && `/${box}`) || ""}`;
}

export function getPaymentAddress(
    addresses: any[] = [],
    shoppingCart?: CartModel | null,
) {
    const paymentAddress = addresses.find(address => {
        if (shoppingCart?.billingAddressId) {
            return address.id === shoppingCart.billingAddressId;
        } else {
            return address.defaultPaymentAddress;
        }
    });

    return paymentAddress || (addresses.length > 0 ? addresses[0] : undefined);
}

export const getAllowedDeliveryAddresses = (addresses: Array<Address>) =>
    addresses.filter(address => address.country === Countries.BE);

export function getDeliveryAddress(
    addresses: any[] = [],
    shoppingCart?: CartModel | null,
): any {
    const deliveryAddress = addresses.find(address => {
        if (shoppingCart?.deliveryAddressId) {
            return address.id === shoppingCart.deliveryAddressId;
        } else {
            return address.defaultDeliveryAddress;
        }
    });

    return (
        deliveryAddress ||
        addresses.find(address => address.country === Countries.BE)
    );
}

export function addressAddPrefix(address: any, prefix?: string): any {
    let transformedAddress: {
        [key: string]: any;
    } = {};

    const formattedPrefix = prefix ? `${prefix}-` : "";

    transformedAddress[`${formattedPrefix}address`] =
        (address.street &&
            address.number &&
            address.zipCode &&
            address.city &&
            `${address.street} ${address.number} ${
                address.box ? `${address.box}` : ""
            } ${address.zipCode} ${address.city}`) ||
        "";

    transformedAddress[`${formattedPrefix}selected`] =
        !!transformedAddress[`${formattedPrefix}address`];

    transformedAddress[`${formattedPrefix}isComplete`] = true;

    Object.keys(address).forEach(key => {
        transformedAddress[`${formattedPrefix}${key}`] = address[key];
    });

    return transformedAddress;
}

export function addressPrefixRemover(address: any, prefix: string): any {
    let transformedAddress: {
        [key: string]: any;
    } = {};

    Object.keys(address).forEach(key => {
        transformedAddress[key.replace(prefix + "-", "")] = address[key];
    });

    return transformedAddress;
}

export function getPrefixOfFIeld(fieldName: string): string {
    const prefix = fieldName.substring(0, fieldName.indexOf("-"));
    return prefix ? `${prefix}-` : "";
}

export function getCreateAddressObject(
    addressing: string,
    firstName: string,
    lastName: string,
    country: string,
    city: string,
    street: string,
    box: string,
    number: string,
    zipCode: string,
    validationStatus: AddressValidationStatus,
    onlyApplicableAsDeliveryAddress: boolean = false,
    onlyApplicableAsPaymentAddress: boolean = false,
): CreateAddress {
    return {
        addressing,
        firstName,
        lastName,
        country,
        city,
        street,
        box,
        number,
        zipCode,
        validationStatus,
        onlyApplicableAsDeliveryAddress,
        onlyApplicableAsPaymentAddress,
    };
}

export function getEmptyAddress(): any {
    return {
        addressing: "",
        firstName: "",
        lastName: "",
        street: "",
        number: "",
        box: "",
        zipCode: "",
        city: "",
        country: "BE",
        address: "",
        selected: false,
        validationStatus: AddressValidationStatus.Unknown,
    };
}
